import { useI18n } from 'vue-i18n';
import { $api } from './useApi';
import type { JourneyData } from '@/models/journey';

export const useJourneyContent = async () => {
  const { locale } = useI18n();

  const { data } = await useAsyncData(`journey-data-${locale}`, async () => {
    return await $api<JourneyData>('/journey-section');
  });

  const journeyData = computed<JourneyData | undefined>(() => data.value);

  return {
    journeyData
  };
};
